// @flow

import React from 'react';
import { Label, FormGroup } from 'reactstrap';

import { CustomSelect } from '../../../../../components/FormikElements';
import useFlightPageContext from '../../../static-db';


const LocationType = ({ title, name }) => {
  const { sectors } = useFlightPageContext();

  return (
    <FormGroup>
      <Label className="title">{title}</Label>
      <CustomSelect className="form-control" name={name} options={sectors} />
    </FormGroup>
  );
};

export default function Location() {
  return (
    <React.Fragment>
      <LocationType title="From" name="fromLocation" />
      <LocationType title="To" name="toLocation" />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/Location.js